import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncAffiliates = async(() =>
  import('@xanadu/ui-shared/components/Affiliates').then(module => module.default)
);

const Affiliates = () => (
  <Switch>
    <Route
      path="/partners/affiliates/:program?"
      component={({
        match: {
          params: {
            urlTitle = 'affiliatesHomeBannerSet'
          }
        }
      }) => (<AsyncAffiliates urlTitle={urlTitle} />)}
    />
    <Redirect
      from="/partners(/*)"
      to="/partners/affiliates"
      component={({
        match: {
          params: {
            urlTitle = 'affiliatesHomeBannerSet'
          }
        }
      }) => (<AsyncAffiliates urlTitle={urlTitle} />)}
    />
  </Switch>
);

export default Affiliates;
